import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { Link } from 'react-router-dom';
import styles from '../stylepacks.module.css';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import type { GraphicItem } from './video-list-graphic.types';
import { useHandleGoToGreenroom } from '@ui/greenroom-button/use-handle-go-to-greenroom';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import qs from 'qs';

export default function VideoCard(video: GraphicItem) {
  const goToGreenroom = useHandleGoToGreenroom(
    qs.stringify({ [video.entityType]: video.id, shots: video.shots.map((shot) => shot.shot_id) })
  );

  return (
    <Container borderRadius="12px" width="auto" className={`overflow-hidden ${styles.card}`}>
      <img src={video.thumbnailUrl} className="width-auto max-width-100-percent" />
      <Container className={`${styles.cardOverlay} flex`} hoverBackground="rgba(var(--gray-1200-rgb), 0.4)" gap="8px">
        <Link to={`./preview/greenroom`} relative="path" state={{ videoId: video.id }}>
          <Button designSize="large" backgroundColor={getThemeColorCSSVariable()}>
            <Text color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}>
              Preview
            </Text>
          </Button>
        </Link>
        <Button designSize="large" round onClick={goToGreenroom} design="LocalBttnSecHalfTransp">
          <Icon name={ICONS.EDIT} size={16} />
        </Button>
      </Container>
    </Container>
  );
}
